import get from 'lodash/get';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import {STATE_CHANGE_SUCCESS} from 'redux-ui-router/lib/action-types';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {logger} from './logger';


export const epics = [
  onLocationChange,
];

onLocationChange.$inject = [
  '$translate',
];

/**
 * Assign the state title to the document title.
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param dependencies
 * @return {Observable<ReduxAction>}
 */
export function onLocationChange(action$, store, dependencies) {
  return action$.ofType(STATE_CHANGE_SUCCESS)
    .filter(action => get(action, 'payload.currentState.title'))
    .switchMap(action => dependencies.$translate(action.payload.currentState.title))
    .do(title => document.title = title)
    .filter(() => false)
    .catch(epicErrorHandler(logger, 'onLocationChange'));
}



// WEBPACK FOOTER //
// ./src/js/app/epics/onLocationChange.js